import { initFaqSectionScript } from '../sections/faq-sections';

initFaqSectionScript();
